<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-07-16 13:56:43
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2022-07-17 18:48:49
 * @FilePath: \manger\src\views\index\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="width: 100%; height: 100%">
    <div
      style="
        width: 100%;
        height: 40%;

        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <img src="../../assets/img/logo.png" alt="" style="height: 40%" />
    </div>
    <div
      style="
        width: 100%;
        height: 60%;
        display: flex;
        justify-content: space-around;
      "
    >
      <div style="width: 48%; height: 100%" class="leftCardBox">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="cardTitleText"><i class="el-icon-menu"></i>区块</span>
            <el-button style="float: right" size="mini">查看详情</el-button>
          </div>
          <div
            style="
              height: 100px;
              display: flex;
              justify-content: space-around;
              align-items: center;
            "
          >
            <div style="height: 100px; width: 48%; padding: 0 25px">
              <div
                style="
                  height: 30px;
                  color: #7f8285;
                  font-weight: 500;
                  line-height: 30px;
                "
              >
                区块高度
              </div>
              <div
                style="
                  height: 70px;
                  color: black;
                  font-weight: 600;
                  font-size: 30px;
                  line-height: 70px;
                "
              >
                {{ areaData.height }}
              </div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div style="height: 100px; width: 48%; padding: 0 25px">
              <div
                style="
                  height: 30px;
                  color: #7f8285;
                  font-weight: 500;
                  line-height: 30px;
                "
              >
                平均出块时间
              </div>
              <div
                style="
                  height: 70px;
                  color: black;
                  font-weight: 600;
                  font-size: 30px;
                  line-height: 70px;
                "
              >
                {{ areaData.avgTime
                }}<span
                  style="color: #9ea2a6; font-size: 15px; font-weight: 400"
                  >秒</span
                >
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="cardTitleText"
              ><i class="el-icon-s-data"></i>交易</span
            >
            <el-button style="float: right" size="mini">查看详情</el-button>
          </div>
          <div
            style="
              height: 100px;
              display: flex;
              justify-content: space-around;
              align-items: center;
            "
          >
            <div style="height: 100px; width: 48%; padding: 0 25px">
              <div
                style="
                  height: 30px;
                  color: #7f8285;
                  font-weight: 500;
                  line-height: 30px;
                "
              >
                24h交易数
              </div>
              <div
                style="
                  height: 70px;
                  color: black;
                  font-weight: 600;
                  font-size: 30px;
                  line-height: 70px;
                "
              >
                {{ dayData.dayNum
                }}<span
                  style="color: #5c5f61; font-size: 15px; font-weight: 400"
                  >笔</span
                >
              </div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div style="height: 100px; width: 48%; padding: 0 25px">
              <div
                style="
                  height: 30px;
                  color: #7f8285;
                  font-weight: 500;
                  line-height: 30px;
                "
              >
                交易总数
              </div>
              <div
                style="
                  height: 70px;
                  color: black;
                  font-weight: 600;
                  font-size: 30px;
                  line-height: 70px;
                "
              >
                {{ dayData.totalNum
                }}<span
                  style="color: #5c5f61; font-size: 15px; font-weight: 400"
                  >笔</span
                >
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <div style="width: 48%; height: 100%">
        <el-card class="box-card right">
          <div slot="header" class="clearfix">
            <span class="cardTitleText">日交易量统计</span
            ><span style="color: #5c5f61; font-size: 15px; font-weight: 400"
              >（最近14天）</span
            >
          </div>
          <div style="height: 45vh">
            <div style="width: 100%; height: 100%" ref="myecharts"></div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      areaData: {},
      dayData: {},
      WeekData: [],
    };
  },
  mounted() {},
  created() {
    this.getareaData();
    this.getDayNum();
    this.getWeekData();
  },
  methods: {
    getWeekData() {
      axios
        .post("/api/tx/getRecentTxNum")
        .then((res) => {
          console.log(res.data.data);
          // this.dayData = res.data.data;
          this.showMyEcharts(res.data.data);
          // res.data
        })
        .catch((err) => {
          // 处理捕获的错误err
          console.log(err);
        });
    },
    showMyEcharts(data) {
      // console.log(moment());
      let dayArr = [];
      for (let i = 1; i <= 14; i++) {
        dayArr.push(moment(moment().add(-i, "days")).format("MM-DD"));
      }
      console.log(dayArr);
      var chartDom = this.$refs.myecharts;
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dayArr.reverse(),
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: data.reverse(),
            type: "line",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#70a2ff73", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#70a2ff73", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    getDayNum() {
      axios
        .post("/api/tx/getDayAndTotalNum")
        .then((res) => {
          // console.log(res.data.data);
          this.dayData = res.data.data;
          // res.data
        })
        .catch((err) => {
          // 处理捕获的错误err
          console.log(err);
        });
    },
    getareaData() {
      axios
        .post("/api/block/getHeightAndAvgTime")
        .then((res) => {
          // console.log(res.data.data);
          this.areaData = res.data.data;
          // res.data
        })
        .catch((err) => {
          // 处理捕获的错误err
          console.log(err);
        });
    },
  },
};
</script>

<style>
.leftCardBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.box-card.right {
  height: 100%;
}
.cardTitleText {
  font-size: 20px;
  font-weight: 800;
}
.el-divider--vertical {
  height: 4em !important;
}
</style>